import React from 'react';
import { NotificationReceiptsTable, NotificationReceiptsTableProps } from '../NotificationReceiptsTable';

interface NotificationReceiptsCardProps {
    isLoading?: boolean;
}

export const NotificationReceiptsCard: React.FC<
    NotificationReceiptsCardProps & NotificationReceiptsTableProps
> = props => {
    const { isLoading, notificationId, notifications, showNotificationIdFilter, extraFilters, isUnsent } =
        props;

    return (
        <NotificationReceiptsTable
            isUnsent={isUnsent}
            isLoading={isLoading}
            notificationId={notificationId}
            notifications={notifications}
            showNotificationIdFilter={showNotificationIdFilter}
            extraFilters={extraFilters}
        />
    );
};
